export const withPrefix = (text) => `[Modal] ${text}`;
